
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const QuickActions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card className="p-6">
      <h2 className="text-lg font-semibold mb-4">{t('dashboard.quickActions.title', 'Hurtige handlinger')}</h2>
      <div className="space-y-4">
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => navigate('/profile')}
        >
          <User className="h-4 w-4 mr-2" />
          {t('dashboard.quickActions.profile', 'Profilindstillinger')}
        </Button>
        <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() => navigate('/notifications')}
        >
          <Bell className="h-4 w-4 mr-2" />
          {t('dashboard.quickActions.notifications', 'Konfigurer notifikationer')}
        </Button>
      </div>
    </Card>
  );
};
